// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gmXM","content":"styles_content__1Yvw9","tableWrap":"styles_tableWrap__1zfXc"};